<footer class="footer">
    <p class="footer-text">Iris CF - Compañía de Financiamiento S.A. - {{currentYear}} Copyright © Todos los derechos
        reservados.</p>
    <p class="footer-text">Dirección IP: {{ip}}</p>

    <div class="social-icons">
        <a href="https://www.linkedin.com/company/irisfinanciera/posts/?feedView=all" target="_blank"
            title="Linkedin"><img src="../../../assets/linkedinLogo.png" alt="Social media icon 1"
                class="social-icon" /></a>
        <a href="https://www.facebook.com/share/wWcHX883QxJMzzk4/?mibextid=LQQJ4d" target="_blank" title="Facebook"><img
                src="../../../assets/facebookLogo.png" alt="Social media icon 2" class="social-icon" /></a>
        <a href="https://www.youtube.com/@iriscompañíadefinanciamiento" target="_blank" title="Youtube"><img
                src="../../../assets/youtubeLogo.png" alt="Social media icon 3" class="social-icon" /></a>
    </div>
</footer>